import { PropertyGrid } from "../../../components/global_components/PropertyGrid";
import { SecondArgumentType } from "../../../types/ArgumentTypes";
import { FieldDisplayOptions, getStandardValueAsString } from "../../../utils/custom_fields/getCustomFieldValue";
import React from "react";
import { StandardFieldValue } from "../../../utils/custom_fields/StandardFieldValue";

/**
 * A row in the PropertyGrid component to display a location field
 */
export function LocationGridRow({
  label,
  value,
  valueType,
  options,
  showWhenEmpty = true, // show the field even when the value is empty
}: {
  label: string;
  value: any;
  valueType: SecondArgumentType<typeof getStandardValueAsString>;
  options?: FieldDisplayOptions;
  showWhenEmpty?: boolean;
}) {
  // don't show the field if the value is null/undefined/empty, but 0 is allowed
  if (!showWhenEmpty && (value === null || value === undefined || value === "")) {
    return null;
  }

  if (!value) {
    return (
      <PropertyGrid.Row label={label} valueString={"--"}>
        --
      </PropertyGrid.Row>
    );
  }
  return (
    <PropertyGrid.Row label={label} valueString={getStandardValueAsString(value, valueType)}>
      <StandardFieldValue value={value} type={valueType} options={options} />
    </PropertyGrid.Row>
  );
}
